import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "frame-wrapper-subsection" }
const _hoisted_2 = { class: "frame-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-wrapper-2" }, "Pourquoi choisir Florisuite ?", -1)
const _hoisted_4 = { class: "frame-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PropertyDefaultWrapper = _resolveComponent("PropertyDefaultWrapper")!
  const _component_Container2 = _resolveComponent("Container2")!
  const _component_Container3 = _resolveComponent("Container3")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_PropertyDefaultWrapper, {
          class: "container",
          heartHandshake: "https://c.animaapp.com/nNxA75tB/img/heart-handshake-2.svg",
          property1: "default"
        }),
        _createVNode(_component_Container2, {
          class: "container",
          handshake: "https://c.animaapp.com/nNxA75tB/img/handshake-2.svg",
          property1: "default"
        }),
        _createVNode(_component_Container3, {
          badgeEuroSign: "",
          class: "container",
          property1: "default"
        })
      ])
    ])
  ]))
}